import { SxStyleProp } from "theme-ui"

// NOTE: It's my first time styling react-select and I couldn't manage to use theme-ui here.
// Probably if I dig deeper I can find a way, but for the sake of time I just hardcoded most values.
// I also wanted to change the svg for the x and caret, but couldn't manage to change them quickly this time.

export const control = ({ isFocused, menuIsOpen }): SxStyleProp => ({
  borderWidth: 2,
  borderColor: isFocused ? "#009FE3" : "hsl(200 10% 90%)",
  boxShadow: "none",
  height: 42,
  fontSize: 16,
  fontFamily: `"IBM Plex Sans",sans-serif`,
  borderRadius: 6,

  "&:hover": {
    borderColor: "",
  },

  "& [class*='indicatorContainer']": {
    transition: "transform 0.25s cubic-bezier(0.32, 0.01, 0, 1)",
    transform: menuIsOpen ? "rotate(180deg)" : "rotate(0deg)",
  },
})

export const placeholder: SxStyleProp = {
  fontSize: 16,
  fontFamily: `"IBM Plex Sans",sans-serif`,
  color: "hsl(200 10% 60%)",
}

export const option = ({ isFocused }): SxStyleProp => ({
  backgroundColor: isFocused ? "hsla(198, 100%, 90%, 1)" : null,
  outlineColor: "#009FE3",

  "&:active": {
    backgroundColor: isFocused ? "hsla(198, 100%, 85%, 1)" : null,
  },
})

export const valueContainer: SxStyleProp = {
  paddingLeft: 10,
}

export const indicatorSeparator: SxStyleProp = {
  display: "none",
}

export const noOptionsMessage: SxStyleProp = {
  fontSize: 12.8,
  fontFamily: `"IBM Plex Sans",sans-serif`,
  color: "hsl(200 10% 40%)",
}

export const multiValue: SxStyleProp = {
  borderRadius: 20,
  backgroundColor: "hsl(200 10% 85%)",
  color: "#000",
  fontSize: 12.8,
  fontFamily: `"IBM Plex Sans",sans-serif`,
}

export const multiValueLabel: SxStyleProp = {
  paddingLeft: 8,
  paddingTop: 4,
  paddingBottom: 4,
  paddingRight: 2,
}

export const multiValueRemove: SxStyleProp = {
  paddingLeft: 2,
  paddingRight: 4,
  borderTopRightRadius: 20,
  borderBottomRightRadius: 20,
  backgroundColor: "transparent",

  "&:hover": {
    backgroundColor: "hsl(200 10% 80%)",
    color: "#000",
  },

  "& svg": {
    width: 14,
    height: 14,
  },
}
